import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=5bedf824&scoped=true&"
import script from "./footer.vue?vue&type=script&lang=js&"
export * from "./footer.vue?vue&type=script&lang=js&"
import style0 from "./footer.vue?vue&type=style&index=0&id=5bedf824&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bedf824",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bedf824')) {
      api.createRecord('5bedf824', component.options)
    } else {
      api.reload('5bedf824', component.options)
    }
    module.hot.accept("./footer.vue?vue&type=template&id=5bedf824&scoped=true&", function () {
      api.rerender('5bedf824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/rosseti/footer.vue"
export default component.exports